"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessionedRequisitionRequestDtoToJSON = exports.AccessionedRequisitionRequestDtoFromJSONTyped = exports.AccessionedRequisitionRequestDtoFromJSON = exports.instanceOfAccessionedRequisitionRequestDto = exports.AccessionedRequisitionRequestDtoSourceEnum = exports.AccessionedRequisitionRequestDtoReqtypeEnum = void 0;
var runtime_1 = require("../runtime");
var AccessionedPatientRequestDto_1 = require("./AccessionedPatientRequestDto");
/**
 * @export
 */
exports.AccessionedRequisitionRequestDtoReqtypeEnum = {
    AnonymousBlood: 'Anonymous Blood',
    Clinical: 'Clinical',
    ClinicalCollaboration: 'Clinical Collaboration',
    Internal: 'Internal',
    PositiveControl: 'Positive Control',
    Research: 'Research'
};
/**
 * @export
 */
exports.AccessionedRequisitionRequestDtoSourceEnum = {
    Api: 'api',
    Backoffice: 'backoffice',
    Cgc: 'cgc',
    ClinicHub: 'clinic_hub',
    Emr: 'emr',
    Fht: 'fht',
    PatientInitiated: 'patient_initiated',
    PatientShare: 'patient_share',
    Portal: 'portal',
    PortalBouncer: 'portal-bouncer',
    Unspecified: 'unspecified'
};
/**
 * Check if a given object implements the AccessionedRequisitionRequestDto interface.
 */
function instanceOfAccessionedRequisitionRequestDto(value) {
    var isInstance = true;
    isInstance = isInstance && "patient" in value;
    return isInstance;
}
exports.instanceOfAccessionedRequisitionRequestDto = instanceOfAccessionedRequisitionRequestDto;
function AccessionedRequisitionRequestDtoFromJSON(json) {
    return AccessionedRequisitionRequestDtoFromJSONTyped(json, false);
}
exports.AccessionedRequisitionRequestDtoFromJSON = AccessionedRequisitionRequestDtoFromJSON;
function AccessionedRequisitionRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'conceptCodes': !(0, runtime_1.exists)(json, 'concept_codes') ? undefined : json['concept_codes'],
        'invitaeStudyCode': !(0, runtime_1.exists)(json, 'invitae_study_code') ? undefined : json['invitae_study_code'],
        'ocrEligible': !(0, runtime_1.exists)(json, 'ocr_eligible') ? undefined : json['ocr_eligible'],
        'patient': (0, AccessionedPatientRequestDto_1.AccessionedPatientRequestDtoFromJSON)(json['patient']),
        'practiceName': !(0, runtime_1.exists)(json, 'practice_name') ? undefined : json['practice_name'],
        'reqtype': !(0, runtime_1.exists)(json, 'reqtype') ? undefined : json['reqtype'],
        'source': !(0, runtime_1.exists)(json, 'source') ? undefined : json['source'],
    };
}
exports.AccessionedRequisitionRequestDtoFromJSONTyped = AccessionedRequisitionRequestDtoFromJSONTyped;
function AccessionedRequisitionRequestDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'concept_codes': value.conceptCodes,
        'invitae_study_code': value.invitaeStudyCode,
        'ocr_eligible': value.ocrEligible,
        'patient': (0, AccessionedPatientRequestDto_1.AccessionedPatientRequestDtoToJSON)(value.patient),
        'practice_name': value.practiceName,
        'reqtype': value.reqtype,
        'source': value.source,
    };
}
exports.AccessionedRequisitionRequestDtoToJSON = AccessionedRequisitionRequestDtoToJSON;
